// extracted by mini-css-extract-plugin
export default {"controls":"EditModal-modules__controls__OHOHB","show-keyframe":"EditModal-modules__show-keyframe__Q3fnc"};